import { render, staticRenderFns } from "./PersonalFiles.vue?vue&type=template&id=ad0e7a36&scoped=true"
import script from "./PersonalFiles.vue?vue&type=script&lang=js"
export * from "./PersonalFiles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad0e7a36",
  null
  
)

export default component.exports